import { createContext, useContext } from 'react';

import { useProfile } from 'context/profile';
import { PERMISSIONS } from 'models/Profile';

export const BASE_PATH = '/configuration/facility-network-status';

// Whose settings these screens show. Without a provider they are the acting client's own, under
// Configuration; Admin > Payer Network Status provides one for the client an Olio admin chose.
export type NetworkStatusScope = {
  clientId?: string;
  clientName: string;
  basePath: string;
  canEdit: boolean;
  // Admin only: where the landing's back arrow goes. Its presence also titles the landing with the client.
  backPath?: string;
};

const NetworkStatusScopeContext = createContext<NetworkStatusScope | null>(null);

export const NetworkStatusScopeProvider = NetworkStatusScopeContext.Provider;

export function useNetworkStatusScope(): NetworkStatusScope {
  const scope = useContext(NetworkStatusScopeContext);
  const { profile } = useProfile();

  return (
    scope ?? {
      clientName: profile.actingClient.name,
      basePath: BASE_PATH,
      canEdit: profile.has(PERMISSIONS.groupPayerNetworkStatusEdit),
    }
  );
}
